import React, { useState } from 'react';
import ProfileV2 from './ProfileV2';

interface ProfileContainerProps {
  tenant: number;
  isSuperKudu: boolean;
  userEmail: string;
  updateQueryString: (email: string) => void;
  queryParams: Record<string, any>;
}

export default function ProfileContainer({
  tenant,
  updateQueryString,
  queryParams,
  userEmail,
  isSuperKudu,
}: ProfileContainerProps) {
  const [isAdminChecked, setIsAdminChecked] = useState<boolean>(false);

  return (
    <>
      <div className="tw-w-full tw-overflow-x-hidden">
        <ProfileV2
          tenant={tenant}
          userEmail={userEmail}
          updateQueryString={updateQueryString}
          queryParams={queryParams}
          isAdminChecked={isAdminChecked}
          isSuperKudu={isSuperKudu}
          onAdminToggle={setIsAdminChecked}
        />
      </div>
    </>
  );
}
